module.exports = __webpack_public_path__ + "img/yape.52756da.png";